const API_URL = process.env.REACT_APP_API_URL || 'https://api.ulitar.com';

export function mapProduct(p, idx = 0) {
  const price = typeof p.price === 'number' ? p.price : parseFloat(p.price) || 0;
  const discount = typeof p.discount === 'number' ? p.discount : 0;
  const img = p.img || '';
  const extras = (p.imageURLs || []).map(u => u.img).filter(Boolean);
  return {
    id: p._id || String(idx + 1),
    slug: p.slug || p._id,
    sku: p._id,
    name: p.title || '',
    price,
    discount,
    offerEnd: null,
    new: p.status === 'new' || false,
    rating: p.rating ? Math.round((p.rating.total / Math.max(p.rating.count, 1)) * 10) / 10 : 4,
    saleCount: 0,
    category: p.category ? [p.category] : ['general'],
    tag: p.category ? [p.category] : [],
    variation: (p.imageURLs || []).map(u => ({
      color: u.color?.name || '',
      image: u.img || img,
      size: (u.sizes || []).map(s => ({ name: s, stock: 10 })),
    })),
    image: [img, ...extras].filter(Boolean).map(src => ({ img: src })),
    shortDescription: p.description || '',
    fullDescription: p.description || '',
  };
}

export async function fetchProducts() {
  try {
    const host = typeof window !== 'undefined' ? window.location.hostname : 'flone.orbitcart.cloud';
    const res = await fetch(`${API_URL}/api/product/all?limit=100`, {
      headers: { 'X-Store-Host': host, 'X-Platform': 'ulitar' },
    });
    if (!res.ok) return null;
    const json = await res.json();
    return (json.data || []).map(mapProduct);
  } catch {
    return null;
  }
}
